import { Promotions } from "../modules/promotions";

export const PromotionsPage = () => {
  return <Promotions />;
};
